import { render, staticRenderFns } from "./InstitutionCompetencesView.vue?vue&type=template&id=386f1fb6&scoped=true"
import script from "./InstitutionCompetencesView.vue?vue&type=script&lang=js"
export * from "./InstitutionCompetencesView.vue?vue&type=script&lang=js"
import style0 from "./InstitutionCompetencesView.vue?vue&type=style&index=0&id=386f1fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f1fb6",
  null
  
)

export default component.exports